import React, { useState, lazy, Suspense } from "react";
import "../../assets/css/agentapps.css";

// Lazy load each section
const UserList = lazy(() => import("../usermanagement/UserList"));
const ClusterList = lazy(() => import("../cloud/ClusterList"));
const CloudList = lazy(() => import("../cloud/CloudList"));
const SchedulerList = lazy(() => import("../scheduler/SchedulerList"));

const TABS = [
  { id: "userManagement", icon: "fa-regular fa-circle-user", label: "User Management" },
  { id: "cluster", icon: "fa-solid fa-dharmachakra", label: "Cluster" },
  { id: "cloud", icon: "fa-solid fa-cloud", label: "Cloud" },
];

const Settings = () => {
  const [activeTab, setActiveTab] = useState("userManagement");
  const [fadeKey, setFadeKey] = useState(0);

  const handleTabChange = (tabId) => {
    if (tabId !== activeTab) {
      setActiveTab(tabId);
      setFadeKey((prev) => prev + 1); // trigger fade animation
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "userManagement": return <UserList />;
      case "cluster": return <ClusterList />;
      case "cloud": return <CloudList />;
      case "scheduler": return <SchedulerList />;
      default: return null;
    }
  };

  return (
    <div className="settings-container-horizontal">
      {/* Sticky Horizontal Tabs */}
      <div className="settings-tabs-container sticky-tabs">
        <div className="settings-tabs-nav">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              className={`settings-tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => handleTabChange(tab.id)}
              role="tab"
              aria-selected={activeTab === tab.id}
            >
              <i className={tab.icon}></i>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main Content with fade animation */}
      <div className="settings-content-area">
        <div key={fadeKey} className="settings-content-wrapper fade-in">
          <Suspense fallback={<div className="loading-text">Loading...</div>}>
            {renderContent()}
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default Settings;
